import { z } from 'zod';
import { WebBlocksApiComponentT } from '../../lib/REST/types.d';

const component: z.ZodSchema<WebBlocksApiComponentT> = z.lazy(() =>
	z
		.object({
			type: z.string(),
			props: z
				.object({
					children: z
						.union([
							component,
							z.array(z.union([component, z.string()])),
							z.string(),
						])
						.optional()
						.nullable(),
				})
				.passthrough(),
		})
		.passthrough()
);

const commonOpts = z.object({
	campaignId: z.string().nonempty(),
	selector: z.string().nonempty().optional(),
	options: z.object({
		stopCondition: z.object({ viewTotal: z.number() }).optional(),
		trigger: z
			.object({ visit: z.object({ total: z.number() }).nullable() })
			.optional(),
	}),
});

const blockNormal = z.intersection(
	commonOpts,
	z.object({
		contentId: z
			.string()
			.nonempty()
			.transform((val, ctx) => {
				const isDefault = val === 'default';

				if (isDefault) {
					ctx.addIssue({
						code: z.ZodIssueCode.custom,
						message: 'Not a default contentId',
					});

					return z.NEVER;
				}

				return val;
			}),
		customJs: z.string().url().optional(),
		replacements: z.array(
			z.object({
				component,
				selector: z.string().nonempty(),
				replacementId: z.string().nonempty().optional(),
				impressionId: z.string().nonempty().optional(),
			})
		),
	})
);

const blockDefault = z.intersection(
	commonOpts,
	z.object({
		contentId: z.literal('default'),
		replacements: z.array(
			z.object({
				component: z.null().optional(),
				selector: z.string().nonempty(),
				replacementId: z.string().nonempty().optional(),
				impressionId: z.string().nonempty().optional(),
			})
		),
	})
);

const blockCustomJsNoContent = z.object({
	campaignId: z.string().nonempty(),
	contentId: z.string().nonempty(),
	customJs: z.string().url().nonempty(),
	replacements: z.array(z.never()).nullable(),
});

export const blockSchema = z.union([
	blockDefault,
	blockNormal,
	blockCustomJsNoContent,
]);
